export const SVG_IMAGES = {
    telemost: require('../../../images/telemost.svg'),
    addUsers: require('../../../images/add-users.svg'),
    admin: require('../../../images/admin.svg'),
    apple: require('../../../images/apple.svg'),
    callCancel: require('../../../images/call-cancel.svg'),
    calendar: require('../../../images/calendar.svg'),
    calendarTextRU: require('../../../images/calendar-text-ru.svg'),
    calendarTextEN: require('../../../images/calendar-text-en.svg'),
    calendarTextTR: require('../../../images/calendar-text-tr.svg'),
    calendarTextUK: require('../../../images/calendar-text-uk.svg'),
    cameraLens: require('../../../images/camera-lens.svg'),
    cameraOffWithSpace: require('../../../images/camera-off-with-space.svg'),
    chat: require('../../../images/chat.svg'),
    close: require('../../../images/close.svg'),
    close2: require('../../../images/close2.svg'),
    closeApp: require('../../../images/close-app.svg'),
    closePromo: require('../../../images/close-promo.svg'),
    copy: require('../../../images/copy.svg'),
    crown: require('../../../images/crown.svg'),
    error: require('../../../images/error.svg'),
    error2: require('../../../images/error2.svg'),
    warning: require('../../../images/warning.svg'),
    warningInCircle: require('../../../images/warning-in-circle.svg'),
    fullscreenIn: require('../../../images/fullscreen-in.svg'),
    fullscreenOut: require('../../../images/fullscreen-out.svg'),
    help: require('../../../images/help.svg'),
    help2: require('../../../images/help2.svg'),
    mobile: require('../../../images/mobile.svg'),
    ios: require('../../../images/ios.svg'),
    logo: require('../../../images/logo.svg'),
    logoHeaderRu: require('../../../images/logo-header-ru.svg'),
    logoHeaderUk: require('../../../images/logo-header-uk.svg'),
    logoHeaderEn: require('../../../images/logo-header-en.svg'),
    logoRu: require('../../../images/logo/logo-ru.svg'),
    logoUk: require('../../../images/logo/logo-uk.svg'),
    logoEn: require('../../../images/logo/logo-en.svg'),
    logoText: require('../../../images/logo-text.svg'),
    logoFullRu: require('../../../images/logo-full-ru.svg'),
    logout: require('../../../images/logout.svg'),
    micOff: require('../../../images/mic-off.svg'),
    micOn: require('../../../images/mic-on.svg'),
    micMuted: require('../../../images/mic-muted.svg'),
    micBlocked: require('../../../images/mic-blocked.svg'),
    more: require('../../../images/more.svg'),
    noInternet: require('../../../images/no_internet.svg'),
    info: require('../../../images/info.svg'),
    participantMic: require('../../../images/participantMic.svg'),
    record: require('../../../images/record.svg'),
    recording: require('../../../images/recording.svg'),
    broadcasting: require('../../../images/broadcasting.svg'),
    recordStop: require('../../../images/record-stop.svg'),
    security: require('../../../images/security.svg'),
    insecurity: require('../../../images/insecurity.svg'),
    settings: require('../../../images/settings.svg'),
    settings2: require('../../../images/settings2.svg'),
    shareScreen: require('../../../images/screen-share.svg'),
    shareScreenBlocked: require('../../../images/screen-share-blocked.svg'),
    shareScreenProcess: require('../../../images/screen-share-process.svg'),
    sound: require('../../../images/sound.svg'),
    star: require('../../../images/star.svg'),
    sync: require('../../../images/sync.svg'),
    triangle: require('../../../images/triangle.svg'),
    user: require('../../../images/user.svg'),
    users: require('../../../images/users.svg'),
    win: require('../../../images/windows.svg'),
    arrow: require('../../../images/arrow.svg'),
    arrowLongBack: require('../../../images/arrow-long-back.svg'),
    selectArrow: require('../../../images/select-arrow.svg'),
    presenterView: require('../../../images/presenter-view.svg'),
    defaultView: require('../../../images/default-view.svg'),
    arrowLeft: require('../../../images/arrow-left.svg'),
    arrowRight: require('../../../images/arrow-right.svg'),
    questionMark: require('../../../images/question-mark.svg'),
    appleIcon: require('../../../images/promo/apple-icon.svg'),
    broadcastEnabled: require('../../../images/broadcast-enabled.svg'),
    broadcastPaused: require('../../../images/broadcast-paused.svg'),
    link: require('../../../images/link.svg'),
    play: require('../../../images/play.svg'),
    pause: require('../../../images/pause.svg'),
    broadcastBig: require('../../../images/broadcast-big.svg'),
    broadcastBigDisabled: require('../../../images/broadcast-big-disabled.svg'),
    newCall: require('../../../images/new-call.svg'),
    audioOn: require('../../../images/audio-on.svg'),
    audioOff: require('../../../images/audio-off.svg'),
    theme: require('../../../images/theme.svg'),

    bear: require('../../../images/participantPlaceholders/bear.svg'),
    cat: require('../../../images/participantPlaceholders/cat.svg'),
    chimpanzee: require('../../../images/participantPlaceholders/chimpanzee.svg'),
    dolphin: require('../../../images/participantPlaceholders/dolphin.svg'),
    fox: require('../../../images/participantPlaceholders/fox.svg'),
    hare: require('../../../images/participantPlaceholders/hare.svg'),
    lion: require('../../../images/participantPlaceholders/lion.svg'),
    octopus: require('../../../images/participantPlaceholders/octopus.svg'),
    owl: require('../../../images/participantPlaceholders/owl.svg'),
    turtle: require('../../../images/participantPlaceholders/turtle.svg'),
    walrus: require('../../../images/participantPlaceholders/walrus.svg'),

    diskLogo: require('../../../images/disk-logo.svg'),
    diskLogoText: require('../../../images/disk-logo-text.svg'),
    virtualBackground: require('../../../images/virtual-background.svg'),
    closeChatCross: require('../../../images/closeChatCross.svg'),

    checkmark: require('../../../images/checkmark.svg'),
    chain: require('../../../images/chain.svg'),
    telegramShare: require('../../../images/telegram-share.svg'),
    whatsappShare: require('../../../images/whatsapp-share.svg'),
    messengerShare: require('../../../images/messenger-share.svg'),
    slackShare: require('../../../images/slack-share.svg'),
    guestIcon: require('../../../images/guest-icon.svg'),
    success: require('../../../images/success.svg'),
    spinner: require('../../../images/spinner.svg'),
    waves: require('../../../images/waves.svg'),

    badgeError: require('../../../images/badge-error.svg'),
    participants: require('../../../images/participants.svg'),
    permissions: require('../../../images/permissions.svg'),
    permissionsBig: require('../../../images/permissions-big.svg'),
    people: require('../../../images/people.svg'),
    admitAll: require('../../../images/admit-all.svg'),
    sort: require('../../../images/sort.svg'),
    leftSort: require('../../../images/left-sort.svg'),
    alfaSort: require('../../../images/alfa-sort.svg'),
    waitingRoomStub: require('../../../images/waiting-room-stub.svg'),
    next: require('../../../images/next.svg'),

    videoLimited: require('../../../images/video-limited.svg'),
    network: require('../../../images/network.svg'),
    indicatorDot: require('../../../images/indicator-dot.svg'),

    //emotions, reactions
    handUp: require('../../../images/hand-up.svg'),
    handDown: require('../../../images/hand-down.svg'),

    //cloud recording
    pulseRecordingDot: require('../../../images/pulse-recording-dot.svg'),

    nda: require('../../../images/release-phase/nda.svg'),
    beta: require('../../../images/release-phase/beta.svg'),

    ndaV2: require('../../../images/release-phase/v2/nda.svg'),

    microphoneDeviceError: require('../../../images/device-error/microphone.svg'),
    cameraDeviceError: require('../../../images/device-error/camera.svg'),

    summarization: require('../../../images/summarization.svg'),
    summarizationInProgress: require('../../../images/summarization-in-progress.svg'),
    summarizationBanner: require('../../../images/summarization-banner.svg'),

    reportAProblem: require('../../../images/report-a-problem.svg'),

    participantsSearchStub: require('../../../images/participants-search-stub.svg'),

    callCalling: require('../../../images/call-calling.svg'),

    conferencesHistoryStub: require('../../../images/conferences-history-stub.svg'),
    conferencesHistoryStubActiveFilter: require('../../../images/conferences-history-stub-active-filter.svg'),
    conferencesHistoryStubFetchingError: require('../../../images/conferences-history-stub-fetching-error.svg'),

    teleMessengerPlaceholder: require('../../../images/telemessenger-placeholder-stub.svg'),

    // Icons for Canvas
    cameraOffSolid: require('@yandex-360/iconostasis/icons/v2/camera-off-solid-md.svg'),
    handSolid: require('@yandex-360/iconostasis/icons/v2/hand-solid-md.svg'),
    microOffSolid: require('@yandex-360/iconostasis/icons/v2/micro-off-solid-md.svg'),
    recordOutlineMd: require('@yandex-360/iconostasis/icons/v2/record-outline-md.svg'),
    userGroupSolid: require('@yandex-360/iconostasis/icons/v2/user-group-solid-md.svg'),
    yaGptSolid: require('@yandex-360/iconostasis/icons/v2/ya-gpt-solid-md.svg'),
    plugins: require('@yandex-360/iconostasis/icons/v2/apps-solid-md.svg'),

    aloneScreenPicture: require('../../../images/alone-screen-picture.svg'),
    nativeAppBannerModal: require('../../../images/native-app-modal/qr.svg'),
    nativeAppBannerSpot: require('../../../images/native-app-banner/spot.svg'),
};

export type ImageName = keyof typeof SVG_IMAGES;
